import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { SurveysService } from 'app/modules/communication/surveys/surveys.service';
import { ViewSurveyComponent } from 'app/modules/communication/surveys/view-survey/view-survey.component';

@Component({
  selector: 'app-active-surveys',
  standalone: true,
  imports: [RouterLink, DatePipe, MatIconModule, FuseCardComponent, MatProgressSpinnerModule],
  templateUrl: './active-surveys.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveSurveysComponent implements OnInit {
  private surveysService = inject(SurveysService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  private matDialog = inject(MatDialog);

  loading = 0;
  surveys: any[] = [];
  error: string = null;

  ngOnInit(): void {
    this.getData();
  }

  openReportModal(survey: any): void {
    this.matDialog.open(ViewSurveyComponent, {
      data: { surveyId: survey.id, title: survey.title },
    });
  }

  private getData(): void {
    this.loading++;
    this.surveysService
      .active(true)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: any) => {
          this.surveys = resp.record || [];
          this.loading--;
          this.cdr.markForCheck();
        },
        error: (error: any) => {
          this.error = error.message || 'An error occurred while loading surveys';
          this.loading--;
          this.cdr.markForCheck();
        },
      });
  }

  /** Backend returns responses_count / contacts_count (withCount); participation is derived from them. */
  participationPct(item: any): number {
    return item?.contacts_count ? Math.round((item.responses_count / item.contacts_count) * 100) : 0;
  }
}
